/**
 * iurop-product.js — lógica de la PDP (MORAY).
 * - Galería: desktop = columna de fotos apiladas con SCROLL PROPIO
 *   (el CSS hace la columna sticky con overflow-y:auto; aquí solo el
 *   contador [n/N] por IO con root = el scroller — scroll de página y
 *   scroll de fotos son independientes, sin secuestrar la rueda);
 *   ≤989px = carrusel scroll-snap con flechas patrón agencia y barra
 *   de progreso. Clic en foto → lightbox.
 * - Variantes: color (miniaturas) + talla (cuadros). Cambiar variante
 *   actualiza precio, tachado, cuota Klarna, badge oferta, stock y foto.
 *   Con "exigir talla" activo, añadir sin talla lleva al selector.
 * - Añadir: intercepta el form → /cart/add.js → `cart:updated`
 *   (iurop-cart-drawer.js re-pinta y abre el sidecart). Sin JS, POST normal.
 * - Sticky ATC (.moray-satc): histéresis por scroll, se esconde sobre el
 *   footer, togglea body.sticky-atc-visible. Se mueve al <body> en el init
 *   (evita quedar atrapada por stacking contexts de la sección).
 * - Upsells "Combínalo con": selector de talla por tarjeta → actualiza el
 *   data-quick-add del botón añadir; si no hay bloques manuales, se rellenan
 *   con recomendaciones vía Section Rendering.
 * - Fecha de entrega: "del 2 al 4 de julio" (salta domingos).
 */
(function () {
  'use strict';

  function money(cents) {
    // € a la DERECHA como iurop-money.liquid (formato tienda ES); el locale
    // sale del documento para no divergir si algún día hay multi-idioma.
    var loc = document.documentElement.lang || 'es-ES';
    return (cents / 100).toLocaleString(loc, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  var mqCarousel = window.matchMedia('(max-width: 989px)');

  function initPdp(root) {
    if (!root || root.dataset.pdpInit) return;
    root.dataset.pdpInit = 'true';

    var variantsEl = root.querySelector('[data-pdp-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]');
    } catch (e) {}

    var requireSize = root.getAttribute('data-require-size') === 'true';
    var sizeIndex = parseInt(root.getAttribute('data-size-index'), 10);
    var installments = parseInt(root.getAttribute('data-installments'), 10) || 3;
    var sizeChosen = !requireSize;

    var qtyInput = root.querySelector('[data-pdp-qty]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var compareEl = root.querySelector('[data-pdp-compare]');
    // Todas las cuotas Klarna (línea de precio + modal +info)
    var klarnaEls = root.querySelectorAll('[data-pdp-klarna]');
    var saleBadge = root.querySelector('[data-pdp-sale-badge]');
    var campaignBadge = root.querySelector('[data-pdp-campaign-badge]');
    var idInput = root.querySelector('[data-pdp-variant-id]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var form = root.querySelector('[data-pdp-form]');

    // Plantilla del CTA. Si la variante inicial está AGOTADA, el servidor
    // pinta "Agotado": capturar ese innerHTML dejaría "Agotado" como
    // etiqueta al cambiar a una variante con stock. En ese caso se
    // reconstruye desde data-pdp-label (y en el sticky se repone el span
    // del total, que el estado agotado no renderiza).
    function ctaTemplateFor(btn, withTotal) {
      if (!btn) return '';
      if (btn.disabled) {
        btn.dataset.soldout = '1';
        var label = btn.getAttribute('data-pdp-label') || '';
        return withTotal
          ? label + '<span class="moray-satc__cta-total" data-pdp-sticky-total hidden></span>'
          : label;
      }
      return btn.innerHTML;
    }
    var ctaTemplate = ctaTemplateFor(addBtn, false);
    var current = variants.length
      ? variants.find(function (v) { return String(v.id) === String(idInput && idInput.value); }) || variants[0]
      : null;

    // --- Fecha de entrega: "del 2 al 4 de julio" (salta domingos) ---
    var deliveryEl = root.querySelector('[data-pdp-delivery]');
    if (deliveryEl) {
      var days = parseInt(root.getAttribute('data-delivery-days'), 10) || 2;

      // Dias HABILES: ni sabados, ni domingos, ni los festivos que declare el
      // comerciante (data-holidays, lista "MM-DD"). Mismo criterio que el
      // snippet de Liquid del carrito, para que las dos fechas coincidan.
      var holidays = (root.getAttribute('data-holidays') || '')
        .split(',')
        .map(function (x) { return x.trim(); })
        .filter(Boolean);

      function isBiz(d) {
        var dow = d.getDay();
        if (dow === 0 || dow === 6) return false;
        var mm = String(d.getMonth() + 1).padStart(2, '0');
        var dd = String(d.getDate()).padStart(2, '0');
        return holidays.indexOf(mm + '-' + dd) === -1;
      }

      function addBizDays(from, n) {
        var d = new Date(from);
        var added = 0;
        var guard = 0;
        while (added < n && guard < 120) {
          d.setDate(d.getDate() + 1);
          guard++;
          if (isBiz(d)) added++;
        }
        return d;
      }
      var maxDays = parseInt(root.getAttribute('data-delivery-days-max'), 10) || (days + 2);
      var d1 = addBizDays(new Date(), days);
      var d2 = addBizDays(new Date(), maxDays);
      var dateLoc = document.documentElement.lang || 'es-ES';
      function fmtDay(d, withMonth) {
        return d.toLocaleDateString(dateLoc, withMonth ? { day: 'numeric', month: 'long' } : { day: 'numeric' });
      }
      var isEnglish = String(dateLoc).toLowerCase().indexOf('en') === 0;
      deliveryEl.textContent = isEnglish
        ? (fmtDay(d1, true) + ' to ' + fmtDay(d2, true))
        : (d1.getMonth() === d2.getMonth()
          ? 'del ' + fmtDay(d1, false) + ' al ' + fmtDay(d2, true)
          : 'del ' + fmtDay(d1, true) + ' al ' + fmtDay(d2, true));
    }

    // (El "paso de fotos por scroll de página" de escritorio — runway +
    // is-stepped + mapeo scroll→foto — se retiró: secuestraba el scroll de
    // la página. Ahora la columna de fotos tiene su PROPIO scroll (CSS) y
    // el navegador enruta la rueda de forma nativa.)

    // --- Galería ---
    var track = root.querySelector('[data-pdp-track]');
    var slides = root.querySelectorAll('[data-pdp-image]');
    var prev = root.querySelector('[data-pdp-prev]');
    var next = root.querySelector('[data-pdp-next]');
    var progressFill = root.querySelector('[data-pdp-progress]');
    var counterCur = root.querySelector('[data-pdp-counter-current]');
    var slideCount = slides.length;

    function pitch() {
      if (!slides.length) return 1;
      var r = slides[0].getBoundingClientRect();
      var gap = 2;
      if (track) {
        var cs = getComputedStyle(track);
        gap = parseFloat(cs.columnGap || cs.gap) || 2;
      }
      return r.width + gap;
    }

    // Posicion REAL de cada foto dentro del track (no aritmetica con el
    // pitch: los redondeos dejaban el destino entre dos fotos).
    function slideLeft(i) {
      if (!track || !slides[i]) return 0;
      return Math.round(slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft);
    }

    function carouselIndex() {
      if (!track) return 0;
      var x = track.scrollLeft;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < slideCount; i++) {
        var d = Math.abs(slideLeft(i) - x);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    function paintGalleryState(idx) {
      // Solo carrusel ≤989: en escritorio el contador lo pinta el IO (el
      // scroll VERTICAL del track también dispara 'scroll' y este cálculo
      // horizontal daría siempre 1).
      if (!mqCarousel.matches) return;
      if (counterCur) counterCur.textContent = idx + 1;
      if (progressFill) progressFill.style.transform = 'translateX(' + idx * 100 + '%)';
      // Patrón agencia: al inicio solo flecha derecha; al final desaparece la
      // derecha. El final se detecta por scroll REAL (en tablet hay 2 slides
      // por vista y el índice nunca llega a slideCount-1).
      var atEnd = track
        ? track.scrollLeft >= track.scrollWidth - track.clientWidth - 2
        : idx >= slideCount - 1;
      if (prev) prev.hidden = idx <= 0;
      if (next) next.hidden = idx >= slideCount - 1 || atEnd;
    }

    var galProg = false;   // hay un scroll PROGRAMATICO en curso
    var galProgTimer = null;
    var galAnim = null;
    var GAL_MS = 320;      // misma duracion para TODOS los cambios de foto
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Animacion propia (en vez del `smooth` del navegador, que dura lo que
    // quiere segun la distancia): asi pasar de foto se siente IGUAL siempre,
    // con la flecha, con el dedo o con el remate.
    function animarScroll(destino) {
      if (galAnim) cancelAnimationFrame(galAnim);
      var desde = track.scrollLeft;
      var delta = destino - desde;
      if (!delta) return;
      var t0 = null;
      function paso(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / GAL_MS);
        // easeOutCubic: arranca rapido y frena; sin rebote.
        var e = 1 - Math.pow(1 - p, 3);
        track.scrollLeft = desde + delta * e;
        if (p < 1) galAnim = requestAnimationFrame(paso);
        else galAnim = null;
      }
      galAnim = requestAnimationFrame(paso);
    }

    function goTo(idx, instante) {
      if (!track) return;
      idx = Math.max(0, Math.min(slideCount - 1, idx));
      var destino = slideLeft(idx);
      var max = track.scrollWidth - track.clientWidth;
      if (destino > max) destino = max;
      if (Math.abs(destino - track.scrollLeft) < 2) return;
      galProg = true;
      if (galProgTimer) clearTimeout(galProgTimer);
      // Con la pestana en segundo plano ninguna animacion de scroll avanza.
      if (instante || document.hidden || reduceMotion.matches) {
        track.scrollLeft = destino;
        galProgTimer = setTimeout(function () { galProg = false; }, 80);
        return;
      }
      animarScroll(destino);
      galProgTimer = setTimeout(function () { galProg = false; }, GAL_MS + 80);
    }

    // Rematar a foto COMPLETA cuando el gesto ha terminado. Se dispara solo
    // con `scrollend` (o, donde no exista, poco despues de soltar el dedo):
    // engancharlo a cada evento `scroll` creaba un bucle que peleaba con la
    // inercia y bloqueaba la galeria.
    function settleGallery() {
      if (!track || galProg || !mqCarousel.matches) return;
      var i = carouselIndex();
      var d = Math.abs(slideLeft(i) - track.scrollLeft);
      if (d <= 2) return;
      // MISMA transicion siempre, venga de la flecha o del dedo: un unico
      // deslizamiento corto (ver goTo). Antes los ajustes pequenos iban secos
      // y los grandes animados, y se notaba que no eran iguales.
      goTo(i);
    }

    if (prev) prev.addEventListener('click', function () { goTo(carouselIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(carouselIndex() + 1); });

    if (track && slideCount > 1) {
      var galTicking = false;
      // El paso foto a foto lo hace el scroll-snap del navegador (mandatory +
      // snap-stop:always en el CSS). NO se corrige por JS: un "snap asistido"
      // que reposiciona el track pelea con la inercia del dedo y deja la
      // galeria bloqueada (probado: no se podia pasar de foto ni con la
      // flecha ni deslizando).
      if ('onscrollend' in window) {
        track.addEventListener('scrollend', settleGallery);
      } else {
        var finTimer = null;
        track.addEventListener('touchend', function () {
          if (finTimer) clearTimeout(finTimer);
          finTimer = setTimeout(settleGallery, 220);
        }, { passive: true });
      }

      track.addEventListener('scroll', function () {
        if (galTicking) return;
        galTicking = true;
        window.requestAnimationFrame(function () {
          galTicking = false;
          paintGalleryState(carouselIndex());
        });
      }, { passive: true });
      paintGalleryState(0);

      // Desktop: el contador sigue a la foto MÁS visible DENTRO del
      // scroller (root = la columna de fotos, no el viewport). Se guarda
      // el ratio de cada slide y gana el mayor: con fotos más altas que
      // la ventana un umbral fijo se quedaba sin entradas.
      if ('IntersectionObserver' in window) {
        var ioRatios = {};
        var io = new IntersectionObserver(function (entries) {
          if (mqCarousel.matches) return; // en carrusel manda el scroll del track
          entries.forEach(function (en) {
            var i = Array.prototype.indexOf.call(slides, en.target);
            if (i > -1) ioRatios[i] = en.intersectionRatio;
          });
          var best = -1;
          var bestR = -1;
          for (var k in ioRatios) {
            if (ioRatios[k] > bestR) { bestR = ioRatios[k]; best = parseInt(k, 10); }
          }
          if (best > -1 && counterCur) counterCur.textContent = best + 1;
        }, { root: track, threshold: [0, 0.25, 0.5, 0.75, 1] });
        // La PRIMERA foto es la sticky de la columna izquierda: siempre esta
        // a la vista y atascaria el contador en "1" — solo se observan las de
        // la columna central.
        slides.forEach(function (sl, i) { if (i > 0) io.observe(sl); });
      }
    }

    function showImage(idx) {
      if (idx === null || idx === undefined || idx < 0 || idx >= slideCount) return;
      if (mqCarousel.matches) {
        goTo(idx);
        return;
      }
      // Desktop: desplazar el scroller INTERNO de la columna de fotos hasta
      // la foto de la variante (no se toca el scroll de página).
      if (track && slides[idx]) {
        var top = slides[idx].getBoundingClientRect().top - track.getBoundingClientRect().top + track.scrollTop;
        if (document.hidden || reduceMotion.matches) track.scrollTop = top;
        else track.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    // --- Cantidad ---
    function getQty() {
      var q = parseInt(qtyInput && qtyInput.value, 10);
      return isNaN(q) || q < 1 ? 1 : q;
    }
    function setQty(q) {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, q);
      // La barra sticky muestra el precio de LO QUE SE VA A ANADIR: al
      // cambiar unidades hay que repintarla (queja: "no se actualiza").
      if (typeof syncPrices === 'function') syncPrices();
    }
    var down = root.querySelector('[data-pdp-qty-down]');
    var up = root.querySelector('[data-pdp-qty-up]');
    if (down) down.addEventListener('click', function () { setQty(getQty() - 1); });
    if (up) up.addEventListener('click', function () { setQty(getQty() + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(getQty()); });

    // --- Sticky ATC (movida al <body> para esquivar stacking contexts) ---
    var sticky = root.querySelector('[data-pdp-sticky]');
    if (sticky) {
      document.querySelectorAll('body > [data-pdp-sticky][data-moray-moved]').forEach(function (old) {
        old.remove(); // restos de un re-render del editor
      });
      sticky.setAttribute('data-moray-moved', 'true');
      document.body.appendChild(sticky);
    }
    var stickyPrice = sticky ? sticky.querySelector('[data-pdp-sticky-price]') : null;
    var stickyCompare = sticky ? sticky.querySelector('[data-pdp-sticky-compare]') : null;
    var stickyBtn = sticky ? sticky.querySelector('[data-pdp-sticky-add]') : null;
    var stickyTemplate = ctaTemplateFor(stickyBtn, true);

    // --- Precios / Klarna / badge oferta ---
    function syncPrices() {
      if (!current) return;
      if (priceEl) priceEl.textContent = money(current.price);
      if (compareEl) {
        var onSale = current.compare_at_price > current.price;
        root.classList.toggle('is-on-sale', onSale);
        compareEl.textContent = onSale ? money(current.compare_at_price) : '';
        compareEl.hidden = !onSale;
        if (saleBadge) {
          if (onSale) {
            saleBadge.hidden = false;
            saleBadge.textContent = Math.round((current.compare_at_price - current.price) * 100 / current.compare_at_price) + '% OFF';
          } else {
            saleBadge.hidden = true;
          }
        }
        if (campaignBadge) {
          var campaignAll = campaignBadge.getAttribute('data-sale-scope') === 'all';
          campaignBadge.hidden = !campaignAll && !onSale;
        }
      }
      klarnaEls.forEach(function (el) {
        el.textContent = money(Math.floor(current.price / installments));
      });
      // Sticky: el precio pequeño muestra SIEMPRE el unitario; el TOTAL
      // (unitario × unidades) va en el botón y solo con qty > 1
      // ("AÑADIR AL CARRITO · 119,90 €"). El span del total se re-busca en
      // cada pasada: setCtaState repone el innerHTML del botón al volver de
      // "Agotado" y una referencia cacheada quedaría muerta.
      if (stickyPrice) stickyPrice.textContent = money(current.price);
      if (stickyCompare) {
        var stickyOnSale = current.compare_at_price > current.price;
        stickyCompare.textContent = stickyOnSale ? money(current.compare_at_price) : '';
        stickyCompare.hidden = !stickyOnSale;
      }
      if (sticky) {
        var stickyTotal = sticky.querySelector('[data-pdp-sticky-total]');
        if (stickyTotal) {
          var q = getQty();
          if (q > 1) {
            stickyTotal.textContent = ' · ' + money(current.price * q);
            stickyTotal.hidden = false;
          } else {
            stickyTotal.textContent = '';
            stickyTotal.hidden = true;
          }
        }
      }
    }

    // --- Variantes ---
    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-pdp-option]').forEach(function (row) {
        var i = parseInt(row.getAttribute('data-pdp-option'), 10);
        var active = row.querySelector('.is-active[data-pdp-value]');
        opts[i] = active ? active.getAttribute('data-pdp-value') : null;
      });
      return opts;
    }

    function setCtaState(btn, template, avail) {
      if (!btn) return;
      btn.disabled = !avail;
      if (avail) {
        if (btn.dataset.soldout === '1') {
          btn.innerHTML = template;
          btn.dataset.soldout = '';
        }
      } else if (btn.dataset.soldout !== '1') {
        btn.dataset.soldout = '1';
        btn.textContent = btn.getAttribute('data-pdp-soldout-text') || 'Agotado';
      }
    }

    function applyVariant(v) {
      if (!v) return;
      current = v;
      if (idInput) idInput.value = v.id;
      setCtaState(addBtn, ctaTemplate, v.available);
      setCtaState(stickyBtn, stickyTemplate, v.available);
      syncPrices();
      if (v.media_index !== null && v.media_index !== undefined) showImage(v.media_index);
      var stock = root.querySelector('[data-pdp-stock]');
      if (stock) {
        var lowThresh = parseInt(stock.getAttribute('data-pdp-low-threshold'), 10) || 0;
        var isLow = v.available && v.inventory_management === 'shopify' &&
          v.inventory_quantity > 0 && v.inventory_quantity <= lowThresh;
        stock.classList.toggle('iurop-pdp__stock--out', !v.available);
        stock.classList.toggle('iurop-pdp__stock--low', isLow);
        var stockLabel = stock.querySelector('[data-pdp-stock-label]');
        var stockDelivery = stock.querySelector('[data-pdp-stock-delivery]');
        if (stockLabel) {
          if (!v.available) stockLabel.textContent = stock.getAttribute('data-pdp-soldout-text') || 'Agotado';
          else if (isLow && v.inventory_quantity === 1) stockLabel.textContent = stock.getAttribute('data-pdp-low-text-one') || (stock.getAttribute('data-pdp-low-text') || '').replace('[count]', 1);
          else if (isLow) stockLabel.textContent = (stock.getAttribute('data-pdp-low-text') || '').replace('[count]', v.inventory_quantity);
          else stockLabel.textContent = stock.getAttribute('data-pdp-instock-text') || 'En stock';
        }
        if (stockDelivery) stockDelivery.hidden = !v.available;
      }
    }

    function resolveVariant() {
      var opts = selectedOptions();
      var matches = variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || opts[i] === undefined || o === opts[i]; });
      });
      if (!matches.length) return null;
      var avail = matches.find(function (v) { return v.available; });
      return avail || matches[0];
    }

    root.querySelectorAll('[data-pdp-option]').forEach(function (row) {
      row.addEventListener('click', function (e) {
        var swatch = e.target.closest('[data-pdp-value]');
        if (!swatch || !row.contains(swatch)) return;
        row.querySelectorAll('[data-pdp-value]').forEach(function (b) {
          b.classList.toggle('is-active', b === swatch);
        });
        var label = row.querySelector('[data-pdp-option-value]');
        if (label) label.textContent = swatch.getAttribute('data-pdp-value');
        var rowIdx = parseInt(row.getAttribute('data-pdp-option'), 10);
        if (rowIdx === sizeIndex) {
          sizeChosen = true;
          row.classList.remove('is-highlight');
          var sizeError = root.querySelector('[data-pdp-size-error]');
          if (sizeError) sizeError.hidden = true;
        }
        applyVariant(resolveVariant());
      });
    });

    // --- Guard de talla: sin talla elegida, añadir lleva al selector ---
    function needsSize() {
      return requireSize && !sizeChosen;
    }
    function highlightSizeRow() {
      var rowEl = root.querySelector('[data-pdp-size-row]');
      if (!rowEl) return;
      var sizeError = rowEl.querySelector('[data-pdp-size-error]');
      if (sizeError) sizeError.hidden = false;
      rowEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      rowEl.classList.remove('is-highlight');
      void rowEl.offsetWidth; // reinicia la animación
      rowEl.classList.add('is-highlight');
    }

    // --- Añadir al carrito (AJAX → cart:updated) ---
    function addToCart(btn) {
      if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
      if (needsSize()) {
        highlightSizeRow();
        return;
      }
      btn.classList.add('is-loading');
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: getQty() }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/add failed');
          return res.json();
        })
        .then(function () {
          // Contrato §5: detail.cart = carrito COMPLETO (add.js solo devuelve
          // la línea añadida; /cart/change.js sí da el carrito → consistencia
          // con lo que emite el drawer). Los receptores toleran cart null.
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        })
        .catch(function () {
          if (form) form.submit();
        })
        .then(function () {
          btn.classList.remove('is-loading');
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(addBtn);
      });
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function () { addToCart(stickyBtn); });

    // --- Mostrar/ocultar la sticky (histéresis + guard de footer) ---
    if (sticky) {
      var stickyTarget = addBtn || form;
      var ticking = false;
      var stuck = false;
      var stickyFooter = document.querySelector('.iurop-footer');

      function evalSticky() {
        ticking = false;
        if (!stickyTarget) return;
        // Con talla agotada la fila de compra se oculta (Avísame): se mide el
        // bloque Avísame visible, o la barra quedaría fija para siempre.
        var target = stickyTarget;
        if (!stickyTarget.offsetParent) {
          target = root.querySelector('[data-moray-bis]:not([hidden])') || form || stickyTarget;
        }
        var r = target.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var offscreen = stuck
          ? r.bottom < 48 || r.top > vh - 48
          : r.bottom < 0 || r.top > vh;
        // nunca sobre el footer
        if (stickyFooter && stickyFooter.getBoundingClientRect().top < vh - 24) {
          offscreen = false;
        }
        if (offscreen === stuck) return;
        stuck = offscreen;
        sticky.classList.toggle('is-visible', offscreen);
        sticky.setAttribute('aria-hidden', offscreen ? 'false' : 'true');
        document.body.classList.toggle('sticky-atc-visible', offscreen);
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(evalSticky);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      evalSticky();
    }

    // --- Upsells "Combínalo con": talla por tarjeta (delegado, sobrevive al swap) ---
    root.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('[data-upsell-size]');
      if (!sizeBtn) return;
      var vid = sizeBtn.getAttribute('data-variant-id');
      if (!vid) return; // talla agotada: navegable pero sin variante que añadir
      var card = sizeBtn.closest('[data-upsell-card]');
      if (!card) return;
      card.querySelectorAll('[data-upsell-size]').forEach(function (b) {
        b.classList.toggle('is-active', b === sizeBtn);
      });
      var add = card.querySelector('[data-quick-add]');
      if (add) add.setAttribute('data-quick-add', vid);
    });

    // Sin upsells manuales → rellenar con recomendaciones (Section Rendering).
    // "Combínalo con" = COMPLEMENTARY (Search & Discovery) con fallback a
    // related si vuelve vacío — los sliders del template ya usan related, así
    // no se duplican los mismos productos 3 veces en la página. La caja llega
    // con `hidden` desde Liquid: solo se destapa tras un swap CON tarjetas.
    var upsellsBox = root.querySelector('[data-pdp-upsells]');
    var recoSectionId = root.getAttribute('data-section-id');
    var recoProductId = root.getAttribute('data-product-id');
    var recoBase = window.routes && window.routes.product_recommendations_url;
    if (upsellsBox && !upsellsBox.querySelector('.iurop-pdp__upsell') && recoSectionId && recoProductId && recoBase) {
      var fillUpsells = function (intent, fallbackIntent) {
        var upsellUrl = recoBase + '?section_id=' + encodeURIComponent(recoSectionId) +
          '&product_id=' + encodeURIComponent(recoProductId) + '&intent=' + intent + '&limit=4';
        fetch(upsellUrl, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            var fresh = null;
            if (html) {
              fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pdp-upsells]');
            }
            if (fresh && fresh.querySelector('.iurop-pdp__upsell')) {
              upsellsBox.innerHTML = fresh.innerHTML;
              upsellsBox.hidden = false;
            } else if (fallbackIntent) {
              fillUpsells(fallbackIntent, null);
            }
          })
          .catch(function () {});
      };
      fillUpsells('complementary', 'related');
    }

    // --- Rating → scroll a las reseñas ---
    // Ancla REAL: la sección de testimonios de la PDP se renderiza con
    // id="shopify-section-template--…__testimonios" (templates/product.json,
    // clave "testimonios"); fallback a la clase del componente. Se scrollea
    // con window.scrollTo y offset del header sticky: scrollIntoView(start)
    // dejaba el título de la sección ESCONDIDO bajo el header (z100).
    function goToReviews() {
      var reviews = document.querySelector('[id^="shopify-section-"][id$="__testimonios"]') ||
        document.querySelector('.iurop-testimonials');
      if (!reviews) return;
      var headerWrap = document.querySelector('.iurop-header');
      var offset = headerWrap ? headerWrap.getBoundingClientRect().height : 0;
      var top = reviews.getBoundingClientRect().top + window.scrollY - offset - 12;
      // En pestana oculta la animacion de scroll no avanza: salto directo.
      window.scrollTo({ top: Math.max(0, top), behavior: document.hidden ? 'auto' : 'smooth' });
    }
    root.querySelectorAll('[data-pdp-rating]').forEach(function (el) {
      el.addEventListener('click', goToReviews);
      // El rating de la buy box es role="button": Enter/Espacio también
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          goToReviews();
        }
      });
    });

    // --- Lightbox de galería ---
    var lightbox = root.querySelector('[data-pdp-lightbox]');
    if (lightbox && slides.length) {
      var lbImg = lightbox.querySelector('[data-lightbox-img]');
      var lbCount = lightbox.querySelector('[data-lightbox-count]');
      var lbIndex = 0;
      var lbLoadToken = 0;
      var lbGalleryItems = Array.prototype.slice.call(slides);
      var lbActiveItems = lbGalleryItems;

      function lbSources() {
        // CAUSA del "la flecha pasa pero la foto no cambia": se elegía
        // SIEMPRE el candidato MAYOR del srcset (3840w). El navegador
        // mantiene pintada la foto anterior hasta que la nueva termina de
        // descargar/decodificar, y un fichero de 3840px tarda tantos
        // segundos que el cambio parecía no ocurrir (el contador sí
        // avanzaba). El tamaño PINTADO lo limita el stage del lightbox
        // (CSS .iurop-lightbox__stage: max-width min(92rem,88vw),
        // max-height 86vh, object-fit contain), NO el viewport entero:
        // pedir innerWidth×dpr elegía de más (móvil 390×3=1170 → 1200w
        // cuando el stage solo pinta ~343css → 1029px físicos; escritorio
        // 1440×2 → tope 1920 → 2200w cuando pinta ~619css → 1238). Se
        // calcula el ancho REAL pintado (min entre ancho del stage y
        // alto×aspect de la foto) × dpr, tope 1920.
        var vw = window.innerWidth || 1200;
        var vh = window.innerHeight || 800;
        var dpr = window.devicePixelRatio || 1;
        var stageW = Math.min(920, vw * 0.88);
        var stageH = vh * 0.86;
        return Array.prototype.map.call(lbActiveItems, function (wrap) {
          var img = wrap.querySelector('img');
          if (!img) return '';

          var iw = parseInt(img.getAttribute('width'), 10) || img.naturalWidth || 0;
          var ih = parseInt(img.getAttribute('height'), 10) || img.naturalHeight || 0;
          var ratio = (iw > 0 && ih > 0) ? iw / ih : 0.8;
          var want = Math.min(1920, Math.ceil(Math.min(stageW, stageH * ratio) * dpr));

          var candidates = (img.srcset || '').split(',').map(function (candidate) {
            var parts = candidate.trim().split(/\s+/);
            return {
              url: parts[0] || '',
              width: parseInt(parts[1], 10) || 0
            };
          }).filter(function (candidate) {
            return candidate.url;
          });

          candidates.sort(function (a, b) {
            return a.width - b.width;
          });

          if (!candidates.length) return img.currentSrc || img.src || '';
          for (var k = 0; k < candidates.length; k++) {
            if (candidates[k].width >= want) return candidates[k].url;
          }
          return candidates[candidates.length - 1].url;
        });
      }

      // Cache de fotos ya decodificadas + precarga de las VECINAS: pasar de
      // foto es instantaneo salvo la primera visita a cada una.
      var lbCache = {};

      function lbWarm(url, done) {
        if (!url || lbCache[url]) { if (done) done(); return; }
        var im = new Image();
        im.onload = im.onerror = function () { lbCache[url] = true; if (done) done(); };
        im.src = url;
      }

      function lbWarmNeighbors(srcs, i) {
        lbWarm(srcs[(i + 1) % srcs.length]);
        lbWarm(srcs[(i - 1 + srcs.length) % srcs.length]);
      }

      // Al ABRIR por primera vez: precalienta TODA la galería en calidad
      // lightbox, EN SERIE (cada foto espera a la anterior: no compite con
      // la que el usuario está mirando) y en hueco idle, ordenada por
      // cercanía a la foto abierta. lbWarm es no-op sobre las ya cacheadas.
      var lbWarmedSets = {};

      function lbIdle(fn) {
        if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 800 });
        else setTimeout(fn, 200);
      }

      function lbWarmAll(srcs, from) {
        if (!srcs.length) return;
        var setKey = srcs.join('|');
        if (lbWarmedSets[setKey]) return;
        lbWarmedSets[setKey] = true;
        var order = [];
        for (var d = 0; d < srcs.length; d++) order.push(srcs[(from + d) % srcs.length]);
        var k = 0;
        (function step() {
          if (k >= order.length) return;
          var u = order[k++];
          lbIdle(function () { lbWarm(u, step); });
        })();
      }

      function lbShow(i) {
        var srcs = lbSources();
        lbIndex = ((i % srcs.length) + srcs.length) % srcs.length;
        var url = srcs[lbIndex];
        if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + srcs.length;
        if (!lbImg || !url) return;
        lbWarmNeighbors(srcs, lbIndex);
        if (lbImg.getAttribute('src') === url) { lbImg.style.opacity = ''; return; }
        if (lbCache[url]) {
          // Ya decodificada: swap directo, sin parpadeo ni atenuado.
          lbLoadToken++;
          lbImg.src = url;
          lbImg.style.opacity = '';
          return;
        }
        // Primera visita: pintar YA como primer frame la variante que el
        // carrusel tiene decodificada (currentSrc del slide) — swap
        // instantaneo, sin hueco ni atenuado — y sustituirla por la grande
        // al onload. Solo si el slide aun no cargo (lazy) se cae al
        // atenuado 0.35. Token anti-carrera (con flechas rapidas solo gana
        // la ultima pulsacion).
        var slideImg = lbActiveItems[lbIndex] && lbActiveItems[lbIndex].querySelector('img');
        var ph = (slideImg && slideImg.complete && slideImg.naturalWidth > 0 && slideImg.currentSrc) || '';
        if (ph) {
          if (lbImg.currentSrc !== ph) lbImg.src = ph;
          lbImg.style.opacity = '';
        } else {
          lbImg.style.opacity = '0.35';
        }
        var token = ++lbLoadToken;
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          lbCache[url] = true;
          if (token !== lbLoadToken) return;
          lbImg.src = url;
          lbImg.style.opacity = '';
        };
        pre.src = url;
      }

      function lbOpen(i, items) {
        lbActiveItems = items && items.length ? items : lbGalleryItems;
        lbShow(i);
        lbWarmAll(lbSources(), lbIndex);
        lightbox.hidden = false;
        document.documentElement.setAttribute('data-lightbox-open', 'true');
      }

      function lbClose() {
        lightbox.hidden = true;
        document.documentElement.removeAttribute('data-lightbox-open');
      }

      slides.forEach(function (wrap, i) {
        wrap.addEventListener('click', function () {
          // (El contador [n/N] ya vive FUERA de los slides, con
          // pointer-events:none: no hace falta guardarlo aquí.)
          lbOpen(mqCarousel.matches ? carouselIndex() : i, lbGalleryItems);
        });
      });

      var ugcItems = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-ugc-open]'));
      ugcItems.forEach(function (item, i) {
        item.addEventListener('click', function () {
          lbOpen(i, ugcItems);
        });
      });

      lightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]')) { lbClose(); return; }
        if (e.target.closest('[data-lightbox-prev]')) { lbShow(lbIndex - 1); return; }
        if (e.target.closest('[data-lightbox-next]')) { lbShow(lbIndex + 1); return; }
        if (!e.target.closest('.iurop-lightbox__stage')) lbClose();
      });

      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') lbClose();
        if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
        if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
      });
    }

    // --- Modales (Klarna «+info» / Guía de Tallas): X, backdrop y Esc ---
    var modalOpener = null;

    function openPdpModal(modal, opener) {
      if (!modal) return;
      modalOpener = opener || null;
      modal.hidden = false;
      document.documentElement.setAttribute('data-moray-modal-open', 'true');
      var closeBtn = modal.querySelector('.iurop-pdp-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closePdpModal(modal) {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.documentElement.removeAttribute('data-moray-modal-open');
      if (modalOpener) {
        modalOpener.focus();
        modalOpener = null;
      }
    }

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-pdp-modal-open]');
      if (opener && root.contains(opener)) {
        openPdpModal(root.querySelector('[data-pdp-modal="' + opener.getAttribute('data-pdp-modal-open') + '"]'), opener);
        return;
      }
      var closer = e.target.closest('[data-pdp-modal-close]');
      if (closer) closePdpModal(closer.closest('[data-pdp-modal]'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openModal = root.querySelector('[data-pdp-modal]:not([hidden])');
      if (openModal) closePdpModal(openModal);
    });

    syncPrices();
  }

  function initAll() {
    document.querySelectorAll('[data-pdp]').forEach(initPdp);
  }

  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
})();
